import actionTypes from '../../actionTypes';

export async function genericThreadAction({
  dispatch,
  getState,
  fetchData,
  actionCreators: { init, success, failure },
  arg}) {
  const oldState = getState();
  !!init && dispatch(init({ arg, oldState }));
  try {
    const data = await fetchData({ arg, oldState, getState });
    !!success && dispatch(success({ data, arg, oldState, getState }));
  } catch(error) {
    !!failure && dispatch(failure({ arg, oldState, error, getState }));
  }
}

export function alertCreate(action) {
  return {
    ...action,
    alert: {
      type: action.type,
      alertType: 'warning',
      error: action.error,
    },
    isAsynchronous: true,
  };
}



// WEBPACK FOOTER //
// ./~/virgo/src/actions/dataActionsCreator/threads/genericThreadActionCreator.js